import React from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const CallToAction = React.forwardRef<HTMLElement, React.HTMLAttributes<HTMLElement>>(
  (props, ref) => {
    return (
      <section ref={ref} className="py-16 bg-accent" aria-labelledby="cta-heading" {...props}>
        <div className="container mx-auto px-4 text-center">
          <h2 id="cta-heading" className="font-display text-3xl md:text-4xl font-bold text-accent-foreground mb-4">
            Join Our Campaign
          </h2>
          <p className="font-body text-lg text-accent-foreground/90 mb-8 max-w-2xl mx-auto">
            Together, we can bring conservative leadership to the 33rd District. Your support makes all the difference.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button variant="cta" size="xl" asChild>
              <Link to="/donate">Donate Now</Link>
            </Button>
            <Button 
              variant="outline" 
              size="xl" 
              asChild
              className="border-2 border-accent-foreground bg-transparent text-accent-foreground hover:bg-accent-foreground hover:text-accent"
            >
              <Link to="/volunteer">Volunteer</Link>
            </Button>
          </div>
        </div>
      </section>
    );
  }
);

CallToAction.displayName = "CallToAction";

export default CallToAction;
